export const SET_SIDENAV_STATUS = 'SET_SIDENAV_STATUS';
export const SET_MOBILE_SIDENAV_STATUS = 'SET_MOBILE_SIDENAV_STATUS';
